import { ActivityDetailController } from './activity-detail-controller';
import { ActivityDetailLangController } from './activity-detail-lang-controller';
import { ActivitySearchController } from './activity-search-controller';

export const controllers = [ActivitySearchController, ActivityDetailController, ActivityDetailLangController];
